import React from 'react';
import logo from '../../assets/logo.png';
import './styles.css'; 

const HeaderSection = ({ title, date, period }) => {
    return (
        <div className="hidden-section">
            <div className="users-management-wrapper">
                <div className="users-management">
                    <h3>{title}</h3>
                </div>
            </div>
            <div className="hidden-logo">
                <div className="hidden-logo-content">
                    <div style={{ flex: 1 }}>
                        <p>Date download: {date}</p>
                        <p>Consultation period: {period}</p>
                    </div>
                    <div style={{ flex: 1, display:'flex', justifyContent: 'center' }}>
                        <img src={logo} alt="Logo" className="logo-img" />
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default HeaderSection;
